import { addAssignedCompanyCode as addAssignedCompanyCodeSession } from "../auth/authSession";

export const STOCK_TYPE_INVENTORY = "Stock-item";
export const STOCK_TYPE_NON_INVENTORY = "Non-Stock-item";

export const STOCK_SCOPE_INVENTORY = "INVENTORY";
export const STOCK_SCOPE_NON_INVENTORY = "NON_INVENTORY";

export const isNonInventoryPath = (pathname = "") =>
  pathname.startsWith("/non-inventory");

export const stockScopeFromPath = (pathname) =>
  isNonInventoryPath(pathname)
    ? STOCK_SCOPE_NON_INVENTORY
    : STOCK_SCOPE_INVENTORY;

export const lockedStockTypeFromPath = (pathname) =>
  isNonInventoryPath(pathname)
    ? STOCK_TYPE_NON_INVENTORY
    : STOCK_TYPE_INVENTORY;

export const requestTypeFromPath = (pathname) =>
  isNonInventoryPath(pathname) ? "NON_INVENTORY" : "INVENTORY";

export const departmentIdFromSearch = (search = "") => {
  const raw = new URLSearchParams(
    search.startsWith("?") ? search.slice(1) : search
  ).get("departmentId");
  if (raw == null || raw === "") return null;
  const parsed = Number(raw);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
};

export const departmentIdFromLocation = (location) =>
  departmentIdFromSearch(location?.search || "");

export const withDepartmentQuery = (url, departmentId) => {
  if (departmentId == null || departmentId === "") return url;
  const sep = url.includes("?") ? "&" : "?";
  return `${url}${sep}departmentId=${departmentId}`;
};

export const withRequestTypeQuery = (url, pathname) => {
  const sep = url.includes("?") ? "&" : "?";
  return `${url}${sep}requestType=${requestTypeFromPath(pathname)}`;
};

export const departmentHref = (path, departmentId) =>
  withDepartmentQuery(path, departmentId);

export const departmentQueryParam = (departmentId) =>
  departmentId == null || departmentId === ""
    ? ""
    : `&departmentId=${departmentId}`;

export const DEPARTMENTS_CHANGED_EVENT = "procurement-departments-changed";

export const hasLaneAccess = (permissions = [], lane = STOCK_SCOPE_INVENTORY) => {
  const hasInventory = permissions.includes("view_inventory");
  const hasNonInventory = permissions.includes("view_non_inventory");
  if (hasInventory || hasNonInventory) {
    return lane === STOCK_SCOPE_NON_INVENTORY ? hasNonInventory : hasInventory;
  }
  // Legacy view_product unlocks inventory only, not /non-inventory/*
  if (permissions.includes("view_product")) {
    return lane !== STOCK_SCOPE_NON_INVENTORY;
  }
  return false;
};

export const notifyDepartmentsChanged = () => {
  window.dispatchEvent(new Event(DEPARTMENTS_CHANGED_EVENT));
};

export const addAssignedCompanyCode = (companyCode) => {
  addAssignedCompanyCodeSession(companyCode);
};

export const productDescriptionApiFromPath = (
  pathname,
  companyCode,
  departmentId
) => {
  const suffix = isNonInventoryPath(pathname)
    ? "all-non-inventory-description"
    : "all-description";
  return withDepartmentQuery(
    `/api/product/${suffix}/${companyCode}`,
    departmentId
  );
};

export const getDepartmentIdForCompany = (companyCode) => {
  if (!companyCode) return null;
  const code = String(companyCode).trim().toUpperCase();
  if (code === "CLW") return 1;
  if (code === "CPS") return 2;
  if (code === "CLT") return 3;
  return null;
};
